import React from 'react'
import SubHeader from '../../layout/components/SubHeader'
function PatientHeader() {
  return (
    <>
        <SubHeader title="Patient File" description={"Patient Data "}>
            <div className="d-flex flex-row justify-content-end align-items-center">
                <div className="d-flex flex-column">
                    <div className="input-group">
                        <span className="input-group-text"><i className="bi bi-search"></i></span>
                        <input type="text" placeholder='Search Patient' className="form-control form-control-sm me-2" />
                    </div>
                    
                    <div className="d-flex flex-row mt-2">
                            <div className="form-check form-check-sm me-2 form-check-custom form-check-solid">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                <label className="form-check-label" htmlFor="flexCheckDefault">
                                    First Name
                                </label>
                            </div>
                            <div className="form-check form-check-sm me-2 form-check-custom form-check-solid">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                <label className="form-check-label" htmlFor="flexCheckDefault">
                                    Last Name
                                </label>
                            </div>
                            <div className="form-check form-check-sm me-2 form-check-custom form-check-solid">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                <label className="form-check-label" htmlFor="flexCheckDefault">
                                    Email
                                </label>
                            </div>


                    </div>
                </div>
            </div>    
        </SubHeader>
    </>
  )
}

export default PatientHeader